import React from 'react'

import style from './Control.module.scss'
import { over1400 } from '~css/breakpoints.module.scss'

const Intro = ({
  microcopy
}) => (
  <div className={[style.description, over1400].join(' ')}>
    { microcopy.text('explorer.messages.intro') }
  </div>
)

export default Intro